var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "room-doc-view-component",
      class: { Customer: _vm.isCounselor },
    },
    [
      _c(
        "div",
        {
          ref: "templateWrapper",
          staticClass: "room-mirroring-template-wrapper",
        },
        [
          _c("RoomMirroringPalette", {
            ref: "palette",
            attrs: { role: _vm.role },
            on: {
              click: ({ e, data }) => {
                _vm.setToolkit(data.toolkit, e)
              },
            },
          }),
          _c(
            "div",
            { staticClass: "w-full min-h-0 flex-1 flex" },
            [
              _vm.hasEmceeRole() ? _c("RoomMirroringSidebar") : _vm._e(),
              _c(
                "div",
                { ref: "iframeWrapper", staticClass: "iframe-wrapper" },
                [
                  _c("iframe", {
                    ref: "view",
                    attrs: {
                      width: _vm.iframe.width,
                      height: _vm.iframe.height,
                      title: "view",
                    },
                    on: { load: _vm.viewLoaded },
                  }),
                ]
              ),
            ],
            1
          ),
          _c("RoomMirroringFooter", {
            on: {
              prev: function ($event) {
                return _vm.setPage(_vm.mirroringCurrentPage - 1)
              },
              next: function ($event) {
                return _vm.setPage(_vm.mirroringCurrentPage + 1)
              },
              submit: _vm.submit,
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }